import(/* webpackMode: "eager" */ "/codebuild/output/src1256965355/src/apex-signals-website/next-web-app/src/app/error.js");
